import { useNavigate } from 'react-router-dom';
import { useIsPlatformUser, useLegalEntityRegions } from '../../hooks/useUser';
import { useEffect } from 'react';

export const AccountsIndex = () => {
  const isPlatformUser = useIsPlatformUser();
  const regions = useLegalEntityRegions();
  const navigate = useNavigate();

  useEffect(() => {
    if (isPlatformUser && regions.length > 0) {
      navigate(regions[0].code.toLowerCase(), {
        replace: true,
      });
    }
  }, [isPlatformUser, regions, navigate]);

  return null;
};
